export default __webpack_public_path__ + "static/media/all-bunnies.82a075e3.png";